@if(visibility()) {
    <div class="text-center">
        @if(description() && !large()) {
        <h4 class="thin">{{ description() }}</h4>
        } @if(description() && large()) {
        <h3 class="thin text--dark-gray">{{ description() }}</h3>
        }
        <div class="loader centered">
        <div class="dot-loader" [class.small-loader]="small()" [ngClass]="{ huge: large(), center: large(), centered: !large(), fast: fast() }"></div>
        </div>
    </div>
}